import { useTranslation } from 'react-i18next';

import { ReactComponent as ZoomInIcon } from '../assets/icons/ZoomInIcon.svg';
import { ReactComponent as ZoomOutIcon } from '../assets/icons/ZoomOutIcon.svg';
import { ReactComponent as ZoomResetIcon } from '../assets/icons/ZoomResetIcon.svg';
import ButtonGroup from '../Button/ButtonGroup';
import IconButton from '../Button/IconButton';
import { MIN_WAVE_SAMPLES } from './const';

interface HorizontalZoomProps {
  // Audio buffer
  audioBuffer: AudioBuffer;
  // Channel data
  channelData: Float32Array;
  // Zoom range
  range?: [number, number];
  // Update zoom range
  updateRange?: (range: [number, number]) => void;
  // Update zoom scale
  updateScale?: (ratio: number) => void;
  // Zoom step(px)
  step?: number;
}

const HorizontalZoom = ({
  audioBuffer,
  channelData,
  range,
  updateRange,
  updateScale,
  step = 0.1,
}: HorizontalZoomProps) => {
  const { t } = useTranslation();

  return (
    <ButtonGroup radius="none" className="editor-zoom">
      {/*
        ISSUE-060 — the names below follow the BEHAVIOUR, not the icon file
        name. `updateScale` is Editor's `updateViewportScale`, which multiplies
        the WIDTH of the visible time window by the ratio, so a ratio above 1
        widens the window and zooms OUT. Both names carry the axis because
        VerticalZoom renders a "Zoom in"/"Zoom out" pair of its own.
      */}
      <IconButton
        aria-label={t('Zoom out horizontally') as string}
        onClick={() => updateScale?.(1 + step)}
        disabled={range && range[1] - range[0] >= audioBuffer.duration}
      >
        <ZoomOutIcon />
      </IconButton>
      <IconButton
        aria-label={t('Reset horizontal zoom') as string}
        onClick={() => updateRange?.([0, audioBuffer.duration])}
        disabled={range && range[1] - range[0] >= audioBuffer.duration}
      >
        <ZoomResetIcon />
      </IconButton>
      <IconButton
        aria-label={t('Zoom in horizontally') as string}
        onClick={() => updateScale?.(1 - step)}
        disabled={channelData.length <= MIN_WAVE_SAMPLES}
      >
        <ZoomInIcon />
      </IconButton>
    </ButtonGroup>
  );
};

export default HorizontalZoom;
